import Eyebrow from './Eyebrow';
import Squiggle from './Squiggle';

type IconName =
  | 'music'
  | 'sparkles'
  | 'palette'
  | 'balloon'
  | 'smile'
  | 'popcorn'
  | 'gem'
  | 'vase'
  | 'spark';

type Tone = 'yellow' | 'teal' | 'blue';

interface Animation {
  label: string;
  icon: IconName;
  tone: Tone;
}

const ANIMATIONS: Animation[] = [
  { label: 'Animation + DJ', icon: 'music', tone: 'yellow' },
  { label: 'Magicien', icon: 'sparkles', tone: 'teal' },
  { label: 'Maquilleuse enfants', icon: 'palette', tone: 'blue' },
  { label: 'Sculpture sur ballons', icon: 'balloon', tone: 'yellow' },
  { label: 'Mascottes', icon: 'smile', tone: 'teal' },
  { label: 'Popcorn & crêpes', icon: 'popcorn', tone: 'blue' },
  { label: 'Atelier bijoux', icon: 'gem', tone: 'yellow' },
  { label: 'Atelier poterie', icon: 'vase', tone: 'teal' },
  { label: 'Démos Lumi (tuteur IA)', icon: 'spark', tone: 'blue' },
];

const ChipIcon = ({ name }: { name: IconName }) => {
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  switch (name) {
    case 'music':
      return (
        <svg {...common}>
          <path d="M9 18V5l12-2v13" />
          <circle cx="6" cy="18" r="3" />
          <circle cx="18" cy="16" r="3" />
        </svg>
      );
    case 'sparkles':
      return (
        <svg {...common}>
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />
        </svg>
      );
    case 'palette':
      return (
        <svg {...common}>
          <path d="M12 2a10 10 0 1 0 0 20c1 0 2-.8 2-2v-1a2 2 0 0 1 2-2h2a4 4 0 0 0 4-4 10 10 0 0 0-10-11z" />
          <circle cx="7.5" cy="10.5" r="1" />
          <circle cx="12" cy="7" r="1" />
          <circle cx="16.5" cy="10.5" r="1" />
        </svg>
      );
    case 'balloon':
      return (
        <svg {...common}>
          <path d="M12 2a6 6 0 0 0-6 6c0 4 3 7 6 8 3-1 6-4 6-8a6 6 0 0 0-6-6z" />
          <path d="M12 16v3M11 22h2" />
        </svg>
      );
    case 'smile':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <circle cx="9" cy="10" r=".5" fill="currentColor" />
          <circle cx="15" cy="10" r=".5" fill="currentColor" />
        </svg>
      );
    case 'popcorn':
      return (
        <svg {...common}>
          <path d="M6 8a3 3 0 0 1 5-2 3 3 0 0 1 5 1 3 3 0 0 1 2 5l-1 9H6L5 12a3 3 0 0 1 1-4z" />
          <path d="M8 12v9M12 11v10M16 12v9" />
        </svg>
      );
    case 'gem':
      return (
        <svg {...common}>
          <path d="M6 3h12l4 6-10 12L2 9z" />
          <path d="M2 9h20M12 3l-4 6 4 12 4-12-4-6z" />
        </svg>
      );
    case 'vase':
      return (
        <svg {...common}>
          <path
            d="M8 3h8v3a4 4 0 0 1-1 3l-1 1v3a5 5 0 0 1-5 5 5 5 0 0 1-5-5v-3l-1-1a4 4 0 0 1-1-3V3z"
            transform="translate(3 0)"
          />
        </svg>
      );
    case 'spark':
      return (
        <svg {...common}>
          <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
          <path d="M19 4v3M20.5 5.5h-3M5 17v3M6.5 18.5h-3" />
        </svg>
      );
  }
};

const Programme = () => (
  <section className="programme">
    <div className="container">
      <div className="programme-head">
        <Eyebrow>Le programme</Eyebrow>
        <h2 className="section-title">
          Sérieux pour les parents.
          <br />
          <span className="section-title-emph">
            Une fête pour les enfants.
            <Squiggle className="title-squiggle" />
          </span>
        </h2>
        <p className="section-lede">
          Pas de réservation horaire&nbsp;: venez quand vous voulez entre 9h et 13h.
          Animations en continu, visites guidées toutes les 30 minutes.{' '}
          <strong>En primaire&nbsp;:</strong> test de positionnement offert sur rendez-vous après la visite.{' '}
          <strong>En maternelle&nbsp;:</strong> rencontre avec les enseignants pour échanger sur le projet pédagogique.
        </p>
      </div>

      <div className="programme-grid">
        {ANIMATIONS.map((a) => (
          <div className={`anim-chip anim-chip-${a.tone}`} key={a.label}>
            <span className="anim-chip-icon">
              <ChipIcon name={a.icon} />
            </span>
            <span className="anim-chip-label">{a.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Programme;
